export var GTM_EVENT_LABELS;

(function (GTM_EVENT_LABELS) {
  GTM_EVENT_LABELS["LANDING_PAGE_LOADED"] = "landing_page_loaded";
  GTM_EVENT_LABELS["QUESTION_ANSWERED"] = "question_answered";
  GTM_EVENT_LABELS["FIRST_FORM_SUBMITTED"] = "first_form_submitted";
  GTM_EVENT_LABELS["LAST_QUESTION_ANSWERED"] = "last_question_answered";
  GTM_EVENT_LABELS["LEAD_CREATED"] = "lead_created";
})(GTM_EVENT_LABELS || (GTM_EVENT_LABELS = {}));